import Rewards from './Rewards'

export default Rewards